const countries = [
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bonaire",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Kosovo",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Saint Pierre and Miquelon",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten (Dutch part)",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican",
  "Venezuela",
  "Vietnam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const allCountries = countries.map((c) => ({ value: c, label: c }));

export const industries = [
  "Aerospace & Defence",
  "Agriculture",
  "Associations & Non Profits",
  "Automotive",
  "Biotech & Pharmaceuticals",
  "Business Services",
  "Construction & Engineering",
  "Consumer Goods & Services",
  "Education",
  "Energy & Utilities",
  "Financial Services",
  "Government",
  "Hardware & Semiconductors",
  "Healthcare & Medical",
  "Hospitality, Travel, & Recreation",
  "Industrial Manufacturing",
  "Information Technology",
  "Internet",
  "Media & Entertainment",
  "Real Estate, Rentals, & Leasing",
  "Software",
  "Telecommunications",
  "Transportation & Logistics",
  "Wholesale & Distribution"
];

export const allIndustries = industries.map((c) => ({ value: c, label: c }));

export const regions = [
  "North America",
  "Latin Americas",
  "Central America",
  "Americas",
  "South Africa",
  "East Africa",
  "West Africa",
  "Africa",
  "APAC",
  "ANZ",
  "Asia",
  "South Asia",
  "South East Asia",
  "East Asia",
  "Middle East",
  "Europe",
  "Central Europe",
  "Eastern Europe",
  "CIS",
  "CZR",
  "Southern Europe",
  "Adriatic",
  "Iberia",
  "Nordics",
  "UK Area",
  "EMEA",
];

export const allRegions = regions.map((c) => ({ value: c, label: c }));

export const compared = [
  "Global",
  "North America",
  "Latin Americas",
  "Central America",
  "Americas",
  "South Africa",
  "East Africa",
  "West Africa",
  "Africa",
  "APAC",
  "ANZ",
  "Asia",
  "South Asia",
  "South East Asia",
  "East Asia",
  "Middle East",
  "Europe",
  "Central Europe",
  "Eastern Europe",
  "CIS",
  "CZR",
  "Southern Europe",
  "Adriatic",
  "Iberia",
  "Nordics",
  "UK Area",
  "EMEA",
];

export const comparedTo = compared.map((c) => ({ value: c, label: c }));

export const introduction = [
  "Automatically generate up-to-date presentations highlighting the recent Cyber threats and trends in any country, region, industry or platform.",
  "The presentations are based on internal Check Point data sources, such as ThreatCloud Threat Map, and include information about:",
];

export const learningLeftList = [
  "Major attacks and data breaches",
  "Trend of attacks per organization",
  "Top malware families and types",
];

export const learningRightList = [
  "Top threat sources",
  "Top malicious file types",
];

export const serviceProvider = [
  `
Service is provided by Check Point Threat Intelligence and Research.
For any questions or comments please 
`,
];
